import React from 'react';
import { Icon } from '@els/els-react--icon';

function WhyRegisterContent() {
  return (
    <div className="u-els-padding-1o2" style={{ position: 'absolute' }}>
      <h2 className="u-els-margin-bottom">Why register on Reaxys</h2>
      <h3 className="u-els-margin-bottom">Register or sign in to unlock key benefits in Reaxys such as:</h3>
      <ul>
        <li className="u-els-flex u-els-align-items-center u-els-margin-bottom u-els-font-size-base u-els-font-family-bold">
          <Icon sprite="AI" size="s" isDecorative className="u-els-margin-right-1o2" />
          Access to Reaxys AI Search Beta
        </li>
        <li className="u-els-flex u-els-align-items-center u-els-margin-bottom u-els-font-size-base">
          <Icon sprite="Clock" size="s" isDecorative className="u-els-margin-right-1o2" />
          Longer session timeout of 6 hours vs. 30 minutes
        </li>
        <li className="u-els-flex u-els-align-items-center u-els-margin-bottom u-els-font-size-base">
          <Icon sprite="Alarm" size="s" isDecorative className="u-els-margin-right-1o2" />
          Set alerts and save searches
        </li>
        <li className="u-els-flex u-els-align-items-center u-els-margin-bottom u-els-font-size-base">
          <Icon sprite="ShoppingCart" size="s" isDecorative className="u-els-margin-right-1o2" />
          Set preferred supplier
        </li>
        <li className="u-els-flex u-els-align-items-center u-els-margin-bottom u-els-font-size-base">
          <Icon sprite="SaveFile" size="s" isDecorative className="u-els-margin-right-1o2" />
          Keep retrosynthesis projects
        </li>
        <li className="u-els-flex u-els-align-items-center u-els-margin-bottom u-els-font-size-base">
          <Icon sprite="LogOut" size="s" isDecorative className="u-els-margin-right-1o2" />
          Export results
        </li>
      </ul>
    </div>
  );
}

export default WhyRegisterContent;
